import axios from '@/axios'
const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////
  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },
  // VxAutoSuggest
  updateStarredPage({ commit, dispatch }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
    dispatch('user/addORupdateBookMark', payload, { root: true })
  },
  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },
  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////
  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },
  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////
  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  async getCityOptions(_, payload) {
    const { search } = payload
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/city/get-cities', {
          params: {
            city_name: search
          }
        })
        .then(function(response) {
          if (response.data.data.length) {
            resolve({
              data: response.data.data.map(city => ({ value: city.id, label: city.city_name })),
              total: response.data.totalCount
            })
          } else {
            reject('Data Not Found.')
          }
        })
        .catch(function(error) {
          reject(error.message)
        })
    })
  },
  async getExpenseCategoryOptions() {
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/expense-category', {
          params: {
            limit: 0,
            page: 1
          }
        })
        .then(function(response) {
          if (response.data.data.length) {
            resolve({
              data: response.data.data.map(expense => ({ value: expense.id, label: expense.category_name })),
              total: response.data.totalCount
            })
          } else {
            reject('Data Not Found.')
          }
        })
        .catch(function(error) {
          reject(error.message)
        })
    })
  },
  async getInventroyOption() {
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/inventories', {
          params: {
            limit: 0,
            page: 1
          }
        })
        .then(function(response) {
          if (response.data.data.length) {
            resolve({
              data: response.data.data.map(inventory => ({ value: inventory.id, label: inventory.category_name }))
            })
          } else {
            reject('Data Not Found.')
          }
        })
        .catch(function(error) {
          reject(error.message)
        })
    })
  }
}
export default actions
